var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"text-500 text-size-xsm"},[_vm._v("Blur:")]),_c('Slider',{attrs:{"suffix":" pt","value":_vm.value},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }